import type { ExitsInvestmentsToCompleteProfile } from '@shared/schemas';

import type { LoadStatus } from '../domain/exits-investments-review.rules';

/**
 * Redux state for the admin "Exit & Investment Review" page and its sidebar
 * badge (#762).
 *
 * `toCompleteCount` lives here rather than in the SideNav so that the list on
 * the page and the badge read one number: the list sets it each time it is
 * read, and the sidebar's count request (`issue-count`, shared with the
 * Profile Cleaning badge) sets it on every other admin page.
 */
export interface ExitsInvestmentsReviewState {
  /** The queue, most recently refreshed first (the server's order). */
  profiles: ExitsInvestmentsToCompleteProfile[];
  loadStatus: LoadStatus;
  /**
   * The badge: the queue's size. `null` until first read (no badge rather than
   * a 0 nobody has checked); a failed read, or a count the server could not
   * make, keeps the last figure.
   */
  toCompleteCount: number | null;
  /**
   * The count request in flight left before the list landed: its figure may
   * be older than the list's, so it must not replace it (#762). Set when the
   * list lands, cleared when a new request leaves or this one answers.
   */
  countInFlightPredatesList: boolean;
}

export const initialState: ExitsInvestmentsReviewState = {
  profiles: [],
  loadStatus: 'idle',
  toCompleteCount: null,
  countInFlightPredatesList: false,
};
